export default "/_next/static/images/1e88785747435e316b51fdc69dcddc14.png";